export default {
  displayPreloader: state => state.displayPreloader,
};
